import { gql, useManualQuery } from '@zenbusiness/application-commons-graphql';
import { useCaptureException, ZBError } from '@zenbusiness/application-commons-logging';

export const PAYMENT_METHOD_LINK_QUERY = gql`
  query PaymentMethodLinkQuery($accountUuid: UUID!) {
    paymentMethodLink(accountUuid: $accountUuid) {
      hostedPaymentMethodUrl
    }
  }
`;

export default function usePaymentMethodLink(accountUuid) {
  const captureException = useCaptureException();
  const [fetchPaymentMethodLinkQuery, { loading }] = useManualQuery(PAYMENT_METHOD_LINK_QUERY, {
    variables: {
      accountUuid,
    },
  });

  const fetchPaymentMethodLink = async () => {
    try {
      const response = await fetchPaymentMethodLinkQuery();
      return response.data?.paymentMethodLink?.hostedPaymentMethodUrl;
    } catch (error) {
      captureException(
        new ZBError(error, {
          message: 'Failed to fetch payment method link',
          contextData: { identifiers: { accountUuid } },
        }),
      );
      return null;
    }
  };

  return {
    fetchPaymentMethodLink,
    loading,
  };
}
